export default "__VITE_ASSET__pmpIiCR8__"